import React from 'react';

function CountryIcon(props) {
    function handleClick() {
        props.changeCountry(props.id);
    }

    const selected = props.selected ? 'icona-selezionata' : '';
    const allIcon = props.id === 0 ? 'icoCategory1-4' : props.categoryIcon;

    return (
        <div className={"icona-slider-paese " + selected} onClick={handleClick}>
            <figure className="paese-icona-live d-flex justify-content-start flex-row">
                <div className={"border img-fluid ico-cat " + allIcon}></div>
                <span>{props.desc}</span>
                <span className="margine-sx">({props.count})</span>
            </figure>
	    </div>
    );
}

export default CountryIcon;